import { createContext as r } from "react";
var o = r({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
});
export { o as IconContext };